import { render, staticRenderFns } from "./CreateSafeSuccessDialog.vue?vue&type=template&id=087435c9&scoped=true"
import script from "./CreateSafeSuccessDialog.vue?vue&type=script&lang=ts"
export * from "./CreateSafeSuccessDialog.vue?vue&type=script&lang=ts"
import style0 from "./CreateSafeSuccessDialog.vue?vue&type=style&index=0&id=087435c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087435c9",
  null
  
)

export default component.exports